import { createContext } from 'react';

/**
 * @public
 */
const PresenceContext = createContext(null);

export { PresenceContext };
